import { JupiterGlobal } from "@jupiter/types";

const fallbackGlobalObject = {};

/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
export function getGlobalObject<T>(): T & JupiterGlobal {
  return (typeof window !== "undefined"
    ? window
    : typeof self !== "undefined"
    ? self
    : fallbackGlobalObject) as T & JupiterGlobal;
}
